// extracted by mini-css-extract-plugin
export default {"category":"Home_category__y4PlF","rating":"Home_rating__RlLyq","item":"Home_item__jF9ml","itemBtn":"Home_itemBtn__9NGuu","addBtn":"Home_addBtn__PaJgZ"};